import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Sidebar } from '../components/Sidebar.js';
import { Topbar } from '../components/Topbar.js';

export function AppLayout() {
  // 移动端（< md）侧栏抽屉开关；md 以上侧栏常驻，这个状态无效果。
  const [navOpen, setNavOpen] = useState(false);
  const { pathname } = useLocation();

  // 路由切换后自动收起抽屉，否则点完菜单抽屉还盖在内容上。
  useEffect(() => {
    setNavOpen(false);
  }, [pathname]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setNavOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    // h-[100dvh] 而非 h-screen：iOS Safari 地址栏收缩时 100vh 会超出可视区，底部内容被吃掉。
    <div className="flex h-[100dvh] overflow-hidden bg-slate-50 dark:bg-slate-950">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onMenuClick={() => setNavOpen((v) => !v)} navOpen={navOpen} />
        <main className="pb-safe flex-1 overflow-auto p-4 md:p-6">
          <Suspense fallback={<div role="status" className="py-16 text-center text-sm text-slate-500">页面加载中…</div>}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
